export interface ButtonGroupButton {
	value: string | number;
	text: string;
}

export enum ButtonThemeState {
	WHITE,
	GREEN,
	PURPLE
}

export interface ContinueButton {
	enabled: boolean;
	busy: boolean;
	text: string;
}
